import { queryClient } from "@/shared/api/query-client";
import { dialogManager } from "@/shared/components/dialog";
import { sheetManager } from "@/shared/components/sheet";

import { useItemStore } from "../store";
import { usePrivacySessionStore } from "./store";

/** 锁定时先移除令牌，再取消在途请求并清除可能包含私密内容的缓存。 */
export function lockPrivacySession({ refetch = true, closeDialogs = true }: { refetch?: boolean; closeDialogs?: boolean } = {}) {
  usePrivacySessionStore.getState().clear();
  useItemStore.getState().actions.closePreview();
  if (closeDialogs) dialogManager.closeAll();
  sheetManager.closeAll();
  void queryClient.cancelQueries();
  if (refetch) {
    void queryClient.resetQueries({ predicate: (query) => query.queryKey[0] !== "auth" });
  } else {
    queryClient.clear();
  }
}

export function activatePrivacySession(token: string, expiresAtSeconds: string) {
  usePrivacySessionStore.getState().unlock(token, Number(expiresAtSeconds) * 1000);
  void queryClient.invalidateQueries();
}
